<template>
  <div class="container">
    <div class="row">
      <div class="col-xs-12">
        <h3 class="title">Guia de instalação do TAG</h3>
        <hr class="h-rule-yellow">
        <hr class="h-rule-side-yellow">
        <h4 class="bold margin-20">Aprenda aqui como instalar seu TAG Move Mais, de maneira rápida e prática.</h4>
      </div>
    </div>

    <div class="alert alert-info">
      <div class="row">
        <div class="col-md-10">
          <div class="alert-info-title">Importante!</div>
          <span class="alert-info-txt">O TAG deve ser colado dentro do veículo, na parte interna do para-brisa e em posição horizontal, pois não irá funcionar se estiver em outra posição.</span>
        </div>
        <div class="col-md-2">
          <img src="../../assets/img/install-guide/img-tag-horizontal-alert.svg" alt="" class="img-tag-fix">
        </div>
      </div>
    </div>

    <div class="row margin-20">
      Para saber a posição correta de instalação, selecione a categoria do veículo abaixo:
    </div>

    <div class="row text-center">
      <div class="col-md-6">
        <a @click="scroll('guide-light-vehicles')">
          <div class="box-light-vehicles">
            <img src="../../assets/img/install-guide/icon-light-vehicles.svg" alt="" width="25%">
            <h4 class="sub-title light-vehicles">Veículos Leves</h4>
            <b>Automóveis, Utilitários, Caminhonetes, etc.</b>
          </div>
        </a>
      </div>
      <div class="col-md-6">
        <a @click="scroll('guide-heavy-vehicles')">
          <div class="box-heavy-vehicles">
            <img src="../../assets/img/install-guide/icon-heavy-vehicles.svg" alt="" width="25%">
            <h4 class="sub-title heavy-vehicles" id="guide-light-vehicles">Veículos Pesados</h4>
            <b>Ônibus, Micro-ônibus, Caminhões, etc.</b>
          </div>

        </a>
      </div>
    </div>

    <section>
      <div class="row">
        <div class="col-xs-12">
          <div class="content-box">
            <h3 class="sub-title light-vehicles">Veiculos Leves</h3>
            <hr class="h-rule-side-yellow">

            <div class="row margin-b20">
              <div class="col-md-7">
                <img src="../../assets/img/install-guide/img-install-tag-car.svg" alt="" class="img-border">
              </div>
              <div class="col-md-5">
                <img src="../../assets/img/install-guide/img-install-tag-car-detail.svg" alt="">
              </div>
              <div class="col-xs-12">
                <div class="text-caption">
                  A maioria dos veículos leves possuem uma área livre próximo ao retrovisor para a aplicação do TAG.
                </div>
              </div>
            </div>

            <div class="row margin-b20">
              <div class="col-xs-12">
                <h4 class="sub-title">Com retícula</h4>
              </div>
              <div class="col-md-7">
                <img src="../../assets/img/install-guide/img-install-tag-car-grid.svg" alt="" class="img-border">
              </div>
              <div class="col-md-5">
                <img src="../../assets/img/install-guide/img-install-tag-car-grid-detail.svg" alt="">
              </div>
              <div class="col-xs-12">
                <div class="text-caption">
                  Caso o veículo tenha retícula (área pontilhada), o TAG deve ser colado fora desta área, logo abaixo, de preferência centralizado no para-brisa.
                </div>
              </div>
            </div>

            <div class="row margin-b20">
              <div class="col-xs-12">
                <h4 class="sub-title">Com suporte ao retrovisor</h4>
              </div>
              <div class="col-md-7">
                <img src="../../assets/img/install-guide/img-install-tag-car-support.svg" alt="" class="img-border">
              </div>
              <div class="col-md-5">
                <img src="../../assets/img/install-guide/img-install-tag-car-support-detail.svg" alt="">
              </div>
              <div class="col-xs-12">
                <div class="text-caption">
                  Há veículos que possuem um suporte ao retrovisor no centro do para-brisa. Neste tipo de veículo, o TAG deve ser colado
em qualquer um dos lados desse suporte, mas deve também respeitar 4 dedos de distância do topo do para-brisa.
                </div>
              </div>
            </div>

            <div class="row margin-b20">
              <div class="col-xs-12">
                <h4 class="sub-title">Com para-brisa panorâmico</h4>
              </div>
              <div class="col-md-4">
                <img src="../../assets/img/install-guide/img-install-tag-car-panoramic-view.svg" alt="" class="img-border">
              </div>
              <div class="col-md-8">
                <div class="text-caption">
                  Caso o veículo tenha retícula (área pontilhada), o TAG deve ser colado fora desta área, logo abaixo, de preferência centralizado no para-brisa.
                </div>
              </div>
            </div>
            <div id="guide-heavy-vehicles" class="position-link"></div>
          </div>
        </div>
      </div>
    </section>

    <section>
      <div class="row">
        <div class="col-xs-12">
          <div class="content-box">
            <h3 class="sub-title heavy-vehicles">Veículos Pesados</h3>
            <hr class="h-rule-side-yellow">

            <div class="row margin-b20">
              <div class="col-xs-12">
                <div class="text-caption">
                  Independentemente de marca ou modelo, a posição do TAG no vidro nunca pode ser coberta pelo curso do limpador do para-brisa. Ache o melhor local com o limpador funcionando.
                </div>
              </div>
            </div>

            <div class="row margin-b20">
              <div class="col-xs-12">
                <h4 class="sub-title upper">Caminhões</h4>
              </div>
              <div class="col-md-7">
                <img src="../../assets/img/install-guide/img-install-tag-truck.svg" alt="" class="img-border">
              </div>
              <div class="col-md-5">
                <img src="../../assets/img/install-guide/img-install-tag-truck-detail.svg" alt="">
              </div>
              <div class="col-xs-12">
                <div class="text-caption">
                  O TAG deve ser colado 10 dedos acima do rodapé do para-brisa, no centro do vidro.
                </div>
              </div>
            </div>

            <div class="row margin-b20">
              <div class="col-xs-12">
                <h4 class="sub-title upper">Ônibus</h4>
              </div>
              <div class="col-xs-12">
                <h4 class="sub-title">Com limpador de para-brisa de baixo para cima</h4>
              </div>
              <div class="col-md-7">
                <img src="../../assets/img/install-guide/img-install-tag-bus-bottom.svg" alt="" class="img-border">
              </div>
              <div class="col-md-5">
                <img src="../../assets/img/install-guide/img-install-tag-bus-bottom-detail.svg" alt="">
              </div>
              <div class="col-xs-12">
                <div class="text-caption">
                  O TAG deve ser colado a uma distância de 1,20m do chão. Caso exista uma barra central no vidro, cole a
                  uma distância mínima lateral de 4 dedos da barra.
                </div>
              </div>
            </div>

            <div class="row margin-b20">
              <div class="col-xs-12">
                <h4 class="sub-title">Com limpador de para-brisa de cima para baixo</h4>
              </div>
              <div class="col-md-7">
                <img src="../../assets/img/install-guide/img-install-tag-bus-top.svg" alt="" class="img-border">
              </div>
              <div class="col-md-5">
                <img src="../../assets/img/install-guide/img-install-tag-bus-bottom-detail-top.svg" alt="">
              </div>
              <div class="col-xs-12">
                <div class="text-caption">
                  O TAG deve ser colado a uma distância de 1,20m do chão. Caso exista uma barra central no vidro, cole a
                  uma distância mínima lateral de 4 dedos da barra.
                </div>
              </div>
            </div>

            <div class="row margin-b20">
              <div class="col-xs-12">
                <h4 class="sub-title">Com limpador de para-brisa de dentro para fora</h4>
              </div>
              <div class="col-md-7">
                <img src="../../assets/img/install-guide/img-install-tag-bus.svg" alt="" class="img-border">
              </div>
              <div class="col-md-5">
                <img src="../../assets/img/install-guide/img-install-tag-bus-detail.svg" alt="">
              </div>
              <div class="col-xs-12">
                <div class="text-caption">
                  O TAG deve ser colado a uma distância entre 1,40m e 1,90m a partir do chão do veículo. Caso exista uma barra central no
                  vidro, cole a uma distância mínima lateral de 4 dedos da barra.
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>

    <div class="alert alert-warning margin-t30">
      <div class="row">
        <div class="col-xs-12">
          <div class="alert-info-title margin-b10">Veículos com particularidades</div>
          Há veículos que possuem particularidades que podem atrapalhar ou mesmo impedir o funcionamento do TAG. Algumas particularidades que podem
          ocasionar problemas de funcionamento: desembaçador de vidro, blindagem e películas com componentes metálicos etc.
          <br/><br/>
          Verifique sempre com os fabricantes e, em caso de dúvida, entre em contato com nossa <b>Central de Relacionamento pelo número 4000 2901
          (regiões metropolitanas) ou 0800 777 1022 (demais localidades).</b>.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    methods: {
      scroll(id){
        $('html, body').stop().animate({
          scrollTop: $("#"+id).offset().top-110
        }, 1000);
      },

    }
  }
</script>

<style scoped lang="scss">
  .alert.alert-info {
    padding: 10px;
  }

  .alert-info-title {
    float: none;
    font-size: 1.2em;
    font-weight: bold;
    margin: 0;
    text-transform: uppercase;
    line-height: auto;
  }

  .alert-info-txt {
    font-size: 1.1em;
    line-height: 23px;
  }

  .img-border {
    border: 2px solid #595a5c;
  }

  .position-link {
    height: 30px;
  }

  .content-box {
    border: 3px solid #f3f3f3;
    margin: 30px 0 10px;
  }

  .box-light-vehicles {
    border: 2px solid #61A60E;
    border-radius: 10px;
    padding: 30px 0;
  }

  .box-heavy-vehicles {
    border: 2px solid #0074C8;
    border-radius: 10px;
    padding: 30px 0;
  }

  .sub-title{
    &.light-vehicles {
      color: #61A60E;
      font-weight: bold;
      margin: 5px 0;
      text-transform: uppercase;
    }
    &.heavy-vehicles {
      color: #0074C8;
      font-weight: bold;
      margin: 5px 0;
      text-transform: uppercase;
    }
  }

  .sub-title {
    font-weight: bold;
  }

  .text-caption {
    font-size: 1.1em;
  }

  @media (max-width: 479px) {

  }
  @media (min-width: 320px) {

  }
  @media (min-width: 480px) {

  }
  @media (max-width: 991px) {
    .alert-info-title {
      float: none;
      line-height: 30px;
      margin: 0;
    }
    .alert-info-txt {
      font-size: 1em;
      line-height: 20px;
    }
    .img-tag-fix {
      margin-top: 10px;
      max-height: 60px;
      text-align: center;
    }
    .box-light-vehicles {
      margin-bottom: 30px;
    }
    .img-border {
      margin-bottom: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// guide.vue?2849b950